var render = function render(){var _vm=this,_c=_vm._self._c;return _c('under-development',{attrs:{"featureName":_vm.$t('StudentProfile.timetable')}})
}
var staticRenderFns = []

export { render, staticRenderFns }